import BillingHTTP from 'utils/billing-http';
import Promise from 'bluebird';
import BaseService from './BaseService';

class ContractFullPaymentService extends BaseService {
  charge(type, contractId, paymentSettings = null) {
    const data = { contract_id: contractId, type, payment_settings: paymentSettings };

    return new Promise((resolve, reject) => {
      BillingHTTP
        .post('/dashboard-api/v2/contract_discharge_requests', data)
        .then((response) => this.pollForPaymentUpdate(response.data.request.id, resolve, reject))
        .catch((error) => reject(error));
    });
  }

  pollForPaymentUpdate(requestId, resolve, reject) {
    setTimeout(() => this.checkForPaymentUpdate(requestId)
      .then((response) => {
        const { request } = response;
        const {
          boleto_payment_promise: boletoPaymentPromise,
          pix_payment_promise: pixPaymentPromise,
        } = request;

        if (request.status !== 'pending'
          || (boletoPaymentPromise && boletoPaymentPromise.bar_code !== null)
          || (pixPaymentPromise && pixPaymentPromise.metadata.qr_code !== null)
        ) {
          resolve(response);
        } else {
          this.pollForPaymentUpdate(requestId, resolve, reject);
        }
      })
      .catch(() => reject()), 1000);
  }

  checkForPaymentUpdate(requestId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/contract_discharge_requests/${requestId}`);
  }

  getExistingPaymentPromise(contractId) {
    return BillingHTTP
      .getContent(`/dashboard-api/v2/contracts/${contractId}/contract_discharge_requests/existing-bill-payment`);
  }
}

export default new ContractFullPaymentService();
